import Loader from "./components/Loader/Loader";
import WarningDialog from "./components/WarningDialog/WarningDialog";
import Router from "./Routes/Router";
import "./App.css";
window.addEventListener("message", function (event: any) {
  if (event.data == "FrameHeight") {
    var body = document.body,
      html = document.documentElement;
    var height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    event.source.postMessage({ FrameHeight: height }, "*");
  }
});
function App() {
  return (
    <div className='App'>
      <WarningDialog />
      <Loader />
      <Router />
    </div>
  );
}

export default App;
